import { Card, Dialog, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CardWrapper = styled(Grid)({
  padding: "5px",
});

export const StyledCard = styled(Card)(({ theme }) => ({
  display: "flex",
  backgroundColor: theme.palette.background.default,
  borderRadius: "0px",
  gap: "10px",
  height: "150px",
}));

export const UndefinedFieldText = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.light,
  // fontStyle: "italic"
}));

export const BlockSelect = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "20px 0px 20px 10px",
});

export const BlockDocumentAndDate = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "20px 0px ",
  textAlign: "center",
});

export const DateContainer = styled(Grid)(({ theme }) => ({
  color: theme.palette.secondary.light,
  display: "flex",
  "& >.MuiTypography-root": {
    fontSize: "28px",
  },
  "& .MuiGrid-root": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    "& .MuiTypography-root": {
      lineHeight: "13px",
    },
  },
}));

export const BlockSubjectFromAndTo = styled(Grid)({
  padding: "20px 10px 20px 0px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
});

export const SectionSubject = styled(Grid)({
  display: "flex",
  // flexDirection: "column",
  // justifyContent: "center",
  width: "100%",
  gap: "5px",
  overflow: "hidden",
  "& .MuiTypography-root": {
    whiteSpace: "nowrap",
    maxWidthwidth: "calc(100%-12ch)",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

export const SectionFromAndTo = styled(Grid)({
  display: "flex",
  justifyContent: "align-left",
  alignItems: "center",
  gap: "20px",
});

export const SectionFrom = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

export const SectionTo = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

export const AddresseeNicknameContainer = styled(Grid)({
  display: "flex",
  gap: "5px ",
});

export const AddresseNickname = styled(Typography)(({ theme }) => ({
  maxWidth: "20ch",
  overflow: "hidden",
  textOverflow: "ellipsis",
  color: theme.palette.primary.main,
}));

export const RecipientsContainer = styled(Grid)({
  display: "flex",
  alignItems: "baseline",
});

export const BlockStatuses = styled(Grid)({
  display: "flex",
  gap: "10px",
});

export const StatusContainer = styled(Grid)({
  minWidth: "140px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px",
  textAlign: "center",
  "& .MuiTypography-root:first-of-type": {
    fontSize: "17px",
  },
});

export const BlockEdit = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "20px 10px 20px 0px",
});

export const DocumentViewerContainer = styled(Dialog)({
  overflow: "hidden",
  "& .MuiPaper-root": {
    maxWidth: "fit-content",
  },
});
